export const truncateToDecimal = (
  value: number,
  decimalPlaces: number = 0
): number => {
  const factor = Math.pow(10, decimalPlaces);
  return Math.floor(value * factor) / factor;
};

export const roundToDecimal = (
  value: number,
  decimalPlaces: number = 0
): number => {
  const factor = Math.pow(10, decimalPlaces);
  return Math.round(value * factor) / factor;
};
